<template>
	<div>
		<div class="filter-panel">
			<div class="filter-height">
				<!-- 所有筛选组 -->
				<div v-for="(option, optionindex) in list" :key="optionindex">
					<div class="filter-group flex-start">
						<div class="filter-label">{{ option.name }}
							<!-- -{{option.key}} -->
						</div>
						<div class="filter-tags">
							<!-- 不限：由当前组的 all 控制 -->
							<div v-if="option.all" class="tag" :class="getItemActiveClass(optionindex, 0)"
								@click="handelSelectItem(optionindex, { id: 0, name: '不限' })">
								不限
							</div>
							<div v-for="(item, index) in option.list" :key="index" class="tag"
								:class="getItemActiveClass(optionindex, item.id)" @click="handelSelectItem(optionindex, item)">
								{{ item.name }}
								<!-- -{{item.id}} -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 操作按钮 -->
			<div class="filter-footer">
				<div class="flex-startCenter">
					已选<span class="color-blue">{{ getAllSelectedCount() }}</span>个
				</div>
				<div class="flex-center">
					<el-button type="active" @click="clearAll()">清空已选</el-button>
					<el-button type="primary" @click="confirmSelected()">确定</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'OptionCard',
		props: {
			list: {
				type: Array,
				required: true,
				default () {
					return []
				},
				/**
				 * list 格式要求
				 * [
				 *   {
				 *     name: '筛选组名称',
				 *     all:true,//  父组件控制：true有不限，false，没有不限
				 *     selectMode: 'single' | 'multiple', // 父组件控制：single=单选，multiple=多选
				 *     list: [{ id: 1, name: '选项1' }, ...]
				 *   },
				 *   ...
				 * ]
				 */
			}
		},
		data() {
			return {
				// 存储每个筛选组的选中项：[{ optionindex: 0, selectedItems: [], selectedIds: '' }, ...]
				selectedMap: []
			}
		},
		methods: {
			/**
			 * 生成选中项id的逗号拼接字符串
			 * @param {Array} items - 选中项数组
			 * @returns {String} 逗号分割的id字符串
			 */
			generateSelectedIds(items) {
				return items.map(item => item.id).join(',');
			},

			/**
			 * 获取单个选项的激活类名
			 */
			getItemActiveClass(optionindex, itemId) {
				const groupSelected = this.selectedMap.find(item => item.optionindex === optionindex)
				if (!groupSelected) return ''
				const isActive = groupSelected.selectedItems.some(item => item.id === itemId)
				return isActive ? 'tag-blue' : ''
			},

			/**
			 * 点击选择选项（根据父组件的 selectMode 处理单选/多选 + 同步更新selectedIds）
			 */
			handelSelectItem(optionindex, item) {
				// 获取当前筛选组的选择模式（默认多选）
				const selectMode = this.list[optionindex]?.selectMode || 'multiple'
				// 查找当前筛选组的选中记录
				const groupIndex = this.selectedMap.findIndex(item => item.optionindex === optionindex)

				// 点击 不限 → 本组只保留不限
				if (item.id === 0) {
					if (groupIndex > -1) {
						this.selectedMap[groupIndex].selectedItems = [{
							id: 0,
							name: '不限'
						}]
						this.selectedMap[groupIndex].selectedIds = '0'
					} else {
						this.selectedMap.push({
							optionindex,
							selectedItems: [{
								id: 0,
								name: '不限'
							}],
							selectedIds: '0'
						})
					}
					return
				}

				// 点击普通项 → 自动移除不限
				if (groupIndex > -1) {
					this.selectedMap[groupIndex].selectedItems = this.selectedMap[groupIndex].selectedItems.filter(i => i.id !== 0)
				}

				if (selectMode === 'single') {
					// 单选逻辑：直接覆盖选中项，仅保留当前点击的
					const newSelectedItems = [item];
					const newSelectedIds = this.generateSelectedIds(newSelectedItems);

					if (groupIndex > -1) {
						this.selectedMap[groupIndex].selectedItems = newSelectedItems;
						this.selectedMap[groupIndex].selectedIds = newSelectedIds;
					} else {
						this.selectedMap.push({
							optionindex,
							selectedItems: newSelectedItems,
							selectedIds: newSelectedIds
						})
					}
				} else {
					// 多选逻辑：切换选中/取消
					let newSelectedItems = [];
					if (groupIndex > -1) {
						const itemIndex = this.selectedMap[groupIndex].selectedItems.findIndex(i => i.id === item.id)
						if (itemIndex > -1) {
							// 取消选择：删除当前项
							newSelectedItems = [...this.selectedMap[groupIndex].selectedItems];
							newSelectedItems.splice(itemIndex, 1);
						} else {
							// 新增选择：添加当前项
							newSelectedItems = [...this.selectedMap[groupIndex].selectedItems, item];
						}
						// 同步更新selectedItems和selectedIds
						this.selectedMap[groupIndex].selectedItems = newSelectedItems;
						this.selectedMap[groupIndex].selectedIds = this.generateSelectedIds(newSelectedItems);
					} else {
						// 首次选择：初始化数组
						newSelectedItems = [item];
						this.selectedMap.push({
							optionindex,
							selectedItems: newSelectedItems,
							selectedIds: this.generateSelectedIds(newSelectedItems)
						})
					}
				}
			},

			/**
			 *  获取所有筛选组的选中总数
			 */
			getAllSelectedCount() {
				return this.selectedMap.reduce((total, group) => {
					const validItems = group.selectedItems.filter(item => item.id !== 0)
					return total + validItems.length
				}, 0)
			},

			/**
			 * 删除指定的选中项
			 * @param {Object} item - 要删除的选项对象 { id, name }
			 */
			deleteSelectedItem(item) {
				// 遍历所有筛选组
				for (let i = 0; i < this.selectedMap.length; i++) {
					const group = this.selectedMap[i]
					const itemIndex = group.selectedItems.findIndex(selected => selected.id === item.id)

					if (itemIndex > -1) {
						// 找到并删除该项
						group.selectedItems.splice(itemIndex, 1)
						group.selectedIds = this.generateSelectedIds(group.selectedItems)

						if (group.selectedItems.length === 0) {
							this.selectedMap.splice(i, 1)
						}

						// 触发确认事件，同步父组件状态
						this.confirmSelected()
						break
					}
				}
			},

			/**
			 * 清空所有选中的项
			 */
			clearAll() {
				this.selectedMap = this.selectedMap.map(group => {
					if (this.list[group.optionindex]?.all) {
						return {
							...group,
							selectedItems: [],
							selectedIds: '0'
						}
					}
					return {
						...group,
						selectedItems: [],
						selectedIds: ''
					}
				}).filter(group => group.selectedItems.length > 0)
				this.$emit('clear') // 通知父组件已清空
				// this.confirmSelected()
			},

			/**
			 *  确认筛选
			 */
			confirmSelected() {
				const groupSelectedData = this.list.map((option, index) => {
					const group = this.selectedMap.find(item => item.optionindex === index)
					// 返回给父组件时，自动过滤掉不限 id=0
					const realSelected = group ? group.selectedItems.filter(i => i.id !== 0) : []
					return {
						optionindex: index,
						optionName: option.name,
						selectMode: option.selectMode,
						selectedItems: realSelected,
						selectedIds: realSelected.length > 0 ? this.generateSelectedIds(realSelected) : ''
					}
				})

				const totalCount = this.getAllSelectedCount()

				const selectedData = {
					totalCount: totalCount, // 总选中个数
					groups: groupSelectedData // 原有分组数据
				}
				// 触发确认事件，传递嵌套后的数据给父组件
				this.$emit('confirm', selectedData)
			}
		}
	}
</script>

<style scoped lang="scss">
	.filter-panel {
		width: 700px;
		padding: 15px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

		.filter-height {
			max-height: 370px;
			overflow-y: auto;
		}

		// 筛选组
		.filter-group {
			margin-bottom: 15px;

			.filter-label {
				font-size: 14px;
				font-weight: 500;
				color: #666;
				margin-bottom: 8px;
				display: inline-block;
				line-height: 36px;
			}

			.filter-tags {
				display: flex;
				flex-wrap: wrap;
				gap: 8px;
				width: 85%;
				margin-left: 20px;
			}
		}

		// 底部按钮
		.filter-footer {
			display: flex;
			justify-content: space-between;
			gap: 10px;
			margin-top: 10px;

			.el-button {
				border-radius: 8px;
				width: 90px;

				&--active {
					border: 1px solid #28b05e;
					color: #28b05e;
				}

				&--primary {
					border: 1px solid #28b05e;
					background-color: #28b05e;
					color: #fff;
				}
			}
		}
	}

	.tag {
		padding: 4px 12px;
		border-radius: 4px;
		cursor: pointer;
		background: #f5f5f5;
		margin-bottom: 0
	}

	.tag-blue {
		background: #28b05e;
		color: #fff;
	}
</style>
